import React, { createContext } from "react";

export const ResearcherContext = createContext({});